export default __webpack_public_path__ + "static/media/museums-victoria-ddKNTAwZu3k-unsplash.8ca087a0.jpg";